<template>
  <div>
    <b-card class="standardpage">
      <b-card-header>
        <b-row>
          <b-col cols="12" sm="6" class="pt-1">
            <i :class="tasks.icon" class="mr-1"></i>
            <span>{{ tasks.title }}</span>
          </b-col>
        </b-row>
      </b-card-header>

      <div v-if="!component" class="availtable datatable">
        <b-card class="w-100pct mb-2">
          <b-card-body class="py-0">
            <b-row v-if="!showfilter">
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="From" label-size="sm">
                  <b-input-group>
                    <b-form-datepicker
                      size="sm"
                      v-model="datefrom"
                      label-help
                      hide-header
                      locale="en-GB"
                      placeholder="From"
                      :debounce="tasks.debounce"
                      :date-format-options="{
                        year: 'numeric',
                        month: 'numeric',
                        day: 'numeric',
                      }"
                    ></b-form-datepicker>

                    <b-input-group-append>
                      <b-button
                        size="sm"
                        squared
                        variant="outline-secondary"
                        :disabled="!datefrom"
                        @click="datefrom = ''"
                      >
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="To" label-size="sm">
                  <b-input-group>
                    <b-form-datepicker
                      size="sm"
                      v-model="dateto"
                      label-help
                      hide-header
                      locale="en-GB"
                      placeholder="To"
                      :debounce="tasks.debounce"
                      :date-format-options="{
                        year: 'numeric',
                        month: 'numeric',
                        day: 'numeric',
                      }"
                    ></b-form-datepicker>

                    <b-input-group-append>
                      <b-button
                        size="sm"
                        squared
                        variant="outline-secondary"
                        :disabled="!dateto"
                        @click="dateto = ''"
                      >
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Name" label-size="sm">
                  <b-input-group>
                    <b-form-input
                      v-model="name"
                      :debounce="tasks.debounce"
                      placeholder="Name"
                    ></b-form-input>
                    <b-input-group-append>
                      <b-button
                        size="sm"
                        variant="outline-secondary"
                        :disabled="!name"
                        @click="name = ''"
                      >
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Category" label-size="sm">
                  <b-input-group>
                    <b-form-input
                      v-model="category"
                      :debounce="tasks.debounce"
                      placeholder="Category"
                    ></b-form-input>
                    <b-input-group-append>
                      <b-button
                        size="sm"
                        variant="outline-secondary"
                        :disabled="!category"
                        @click="category = ''"
                      >
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label="Level" label-for="level" label-cols="12">
                  <treeselect
                    instanceId="level"
                    type="number"
                    v-model="level"
                    :clearable="false"
                    :options="level_options"
                  ></treeselect>
                </b-form-group>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
        <div class="px-3">
          <d-table
            classdivtable="availtable datatable"
            refid="tasks"
            :icon="tasks.icon"
            :busy="tasks.busy"
            :toolbarlibrary="tasks.toolbarlibrary"
            :tools="tasks.tools"
            :badges="tasks.badges"
            :fields="tasks.fields"
            :items="tasks.items"
            :limit="tasks.limit" 
            :page="tasks.page"
            @load="tasks_load"
            @click="tasks_click"
            @select="tasks_select"
          >
          </d-table>
        </div>
      </div>
      <div v-if="component">
        <component
          :is="component"
          :selection="tasks.selected"
          :config="cconfig"
          @discard="tasks_click('discard')"
          @refresh="tasks_click('refresh')"
        ></component>
      </div>
    </b-card>
  </div>
</template>
  
  <script>
import gql from "graphql-tag";
import TaskView from "./Components/TaskView";

export default {
  name: "Tasks",
  components: { TaskView },
  watch: {
    async datefrom() {
      await this.tasks_load(0);
    },
    async dateto() {
      await this.tasks_load(0);
    },
    async name() {
      await this.tasks_load(0);
    },
    async category() {
      await this.tasks_load(0);
    },
    async level() {
      await this.tasks_load(0);
    },
  },
  data() {
    return {
      busy: false,
      datefrom: this.$moment().format("YYYY-MM-DD"),
      dateto: this.$moment().format("YYYY-MM-DD"),
      received_at: this.$moment().format("YYYY-MM-DD"),
      name: null,
      category: null,
      level: null,
      level_options: [
        { id: "0", label: "Information" },
        { id: "1", label: "Error" },
        { id: "2", label: "Warning" },
      ],
      tasks: {
        title: "Task Viewer",
        icon: "fa fa-tasks pl-2",
        debounce: 500,
        busy: false,
        page: 1,
        offset: 0,
        limit: 15,
        tools: "go,filter,export,info,deleteconfirm",
       
        toolbarlibrary: [
          {
            type: "button",
            size: "sm",
            variant: "outline-white",
            squared: "squared",
            icon: "fa fa-expand text-primary",
            position: "toolbar",
            action: "info",
            label: "View",
            component: {
              name: "TaskView",
            },
          },

          // { key: "is_separator", type: "separator" },
        ],
       
        // view: [],
        fields: [
          {
            key: "selected",
            label: "...",
            class: "text-center w-25px",
          },
          {
            key: "icon",
            label: "",
            class: "text-right",
          },
          {
            key: "level",
            label: "Level",
            sortable: true,
            sortDirection: "desc",
            type: "text",
          },
          {
            key: "created_at",
            label: "Received",
            class: "d-none d-sm-table-cell",
            sortable: true,
            // formatter: (value, key, item) => {
            //   let result = "Never";
            //   if (value) {
            //     result = this.$moment
            //       .unix(value / 1000)
            //       .format("DD/MM/YYYY HH:mm:SS");
            //   }
            //   return result;
            // },
          },
          {
            key: "name",
            label: "Event",
            sortable: true,
            sortDirection: "desc",
            type: "text",
          },

          {
            key: "category",
            label: "Category",
            sortable: true,
            sortDirection: "desc",
            type: "text",
          },
          {
            key: "data",
            type: "text",
            class: "text-left",
            formatter: (value, key, item) => {
              let result = "";
              if (value) {
                result = value.split("\n")[0];
              }
              return result;
            },
          },
          {
            key: "actions",
            label: "Actions",
            class: "actions w-100px",
          },
        ],
        badges: [
          {
            key: "level",
            type: "badge",
            Information: "info",
            Error: "danger",
            Warning: "warning",
            formatter: (value, key, item) => {
              switch (parseInt(value)) {
                case 0:
                  return "Information";
                  break;
                case 1:
                  return "Error";
                  break;
                case 2:
                  return "Warning";
                  break;
                default:
                  return value;
              }
            },
          },
        ],
        // actions: [
        //   {
        //     key: "info",
        //     label: "Info",
        //     icon: "fa fa-expand",
        //     single: true,
        //     multiple: false,
        //     component: {
        //       name: "TaskView",
        //     },
        //   },
        // ],
        items: [],
        selected: [],
        denied: [],       
      },
    };
  },
  async mounted() {
    // this.accessdenied();
    await this.tasks_load();
  },
  methods: {
    // accessdenied() {
    //   this.tasks.denied = [];
    //   if (!this.user.permissions.includes("tasks.delete")) {
    //     this.tasks.denied.push("delete");
    //   }
    //   if (!this.user.permissions.includes("tasks.save")) {
    //     this.tasks.denied.push("save");
    //   }

    // },
    async tasks_load(offset, limit, page) {
      let state = this.tasks;

if (offset || offset == 0) {
  state.offset = offset
}
if (limit || limit == 0) {
  state.limit = limit
}
if (page) {
  state.page = page
}

state.busy = true;

let variables = {
  offset: state.offset,
  limit: state.limit,

        name: this.name,
        level: this.level,
        category: this.category,
        datefrom: this.datefrom,
        dateto: this.dateto,
        dateformat: this.dateformat,
      };
      console.log("variables", variables);

      try {
        const response = await this.$apollo.query({
          query: gql`
            query tasks(
              $datefrom: String
              $dateto: String
              $name: String
              $category: String
              $level: String
              $data: String
              $created_at: String
            ) {
              tasks(
                datefrom: $datefrom
                dateto: $dateto
                name: $name
                category: $category
                level: $level
                data: $data
                created_at: $created_at
              ) {
                id
                name
                category
                level
                data
                created_at
              }
            }
          `,
          variables,
        });

        if (limit == 0) {
          state.selected = response.data.tasks
        } else {
          state.items = []
          state.items = response.data.tasks;
        }

      } catch (error) {
        console.log(error);
      }
      state.busy = false;
    },
    // tasks_toolbar(s) {
    //   if (this.tasks.toolbar) {
    //     let toolbar = this.tasks.toolbar;
    //     for (var j = 0; j < toolbar.length; j++) {
    //       let tool = toolbar[j];
    //       switch (tool.action) {
    //         case "filter":

    //         case "info":
    //         // case "add":
    //         case "export":
    //         case "refresh":
    //           tool.disabled = false;
    //           break;

    //         // case "edit":
    //         //   tool.disabled = s.length == 1 ? false : true;
    //         //   break;

    //         default:
    //           tool.disabled = true;
    //       }

    //       if (this.tasks.denied.includes(tool.action)) {
    //         tool.visible = false;
    //       }
    //     }
    //   }
    // },

    async tasks_click(a, ss) {

      switch (a) {
        case "filter":
          this.showfilter = !this.showfilter;
          break;
        case "discard":
        case "go":
          this.component = null;
          this.tasks_load();
          break;      
        case "info":
          this.component = "TaskView";
          break;

        case "delete":
          this.deleteit(ss);
          break;
      }
    },

    async tasks_select(ss, tools) {

      let state = this.tasks;

      state.selected = ss;
      let tool = null;

      if (tools) {
        let enabled = ["back", "save", "go", "filter", "export"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = false;
          }
        });
        // == 1
        enabled = ["info"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = ss.length == 1 ? false : true;
          }
        });
        // > 1
        enabled = ["deleteconfirm"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = ss.length > 0 ? false : true;
          }
        });

        if (!state.denied) {
          state.denied = [];
        }
        state.denied.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.visible = false;
          }
        });
      }
    },

    async deleteit(s) {
      console.log("deleteit", s);
      let rows = this.$helpers.prepareforSave(s);

      let variables = { rows };
      console.log(variables);
      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
            mutation deletetask($rows: [Task_input]) {
              deletetask(rows: $rows) {
                id
              }
            }
          `,
          variables,
        });

        console.log(response);
      } catch (error) {
        console.log(error);
      }

      await this.tasks_load(0);
    },
  },
};
</script>
  
  <style>
</style>